<template>
	<div class="login-container">
		<div class="top">
			<div v-if="!is_login" class="login-box">
				<div class="login-form" @keyup.enter="submit">

					<div v-if="login_mode === 'form'" class="form">
						<div class="tabs">
							<div @click="form_scene = 'login'" class="tabs-btn" :class="form_scene === 'login' ? 'active' : ''">
								Login</div>
							<div @click="form_scene = 'register'" class="tabs-btn"
								:class="form_scene === 'register' ? 'active' : ''">Register</div>
						</div>
						<div class="form-content">
							<div class="form-item">

								<input style="margin-left:20px;" v-model="form_data.email" placeholder="Enter email" />
							</div>
							<div class="form-item" v-if="login_method === 'email' || form_scene === 'register'">
								<input style="margin-left:20px;" v-model="form_data.code" placeholder="Enter code" />
								<email-code class="btn-code" :scene="form_scene==='register'?'register':'login' " :email="form_data.email"></email-code>
							</div>
							<template v-if="login_method === 'account' || form_scene === 'register'">
								<div class="form-item">
									<input style="margin-left:20px;" v-model="form_data.password" placeholder="Enter password"
										:type="password_type" />
									<div style="margin-right:20px;">
										<img @click="password_type = password_type =='text' ? 'password' :'text'"
											:src="password_type == 'text' ? require('../../assets/images/icon-open-eye.png'):require('../../assets/images/icon-close-eye.png')"
											style="width:18px;height:12px;" />
									</div>
								</div>
								<!-- <div v-if="login_method === 'account' && form_scene === 'login'" class="form-item">
									<input style="margin-left:20px;" v-model="form_data.captcha_code"
										placeholder="Enter captcha" />
									<span class="btn-code" :style="{top:'6px',marginRight:login_method === 'account' ? '20px' : '0'}">
										<captcha class="captcha" :width="90" :height="35" :outcode.sync="captcha_code">
										</captcha>
									</span>
								</div> -->
							</template>
							<div style="display:flex;justify-content:space-between;align-items: center;margin-top:10px;flex:1;">
								<div v-if="form_scene === 'login'" @click="login_method = login_method === 'email' ? 'account' : 'email'" class="login-mode">
									{{ login_method === 'email' ? 'account login' : '' }}</div>
									<div style="color:#303234;font-size:12px;cursor:pointer;" @click="go2find">Forgot your password?</div>
							</div>
						</div>
						
						<div class="btn-submit" @click="submit">Submit</div>
						<div class="flex align-center justify-between padding-tb" style="padding:10px 0;">
						
 							<button class="custom-btn" @click="handleGoogleLogin">
								<img src="../../assets/images/login-icon-google.png" class="icon" />
							</button>
							<!-- <button class="custom-btn" style="margin-left:10px;" @click="handleAppleLogin">
								<img src="../../assets/images/login-icon-apple.png" class="icon" />
							</button> -->
						</div>
						<div style="color:#B1B2B3;font-size:12px;width:100%;text-align:center;">
							By logging in, you agree to <span class="cursor" style="color:#000000;" @click="open_agreement">our terms and privacy policy </span>
						</div>
					</div>

				</div>
			</div>
		</div>
		<div class="second">
			<div class="bg"></div>
			<div class="content">
				<div class="title">
					<p>One-Stop Apparel Sample Production</p>
					<p>Full Category Support · Tailored for Designers</p>
				</div>
				<div class="list">
					<img src="../../assets/images/icon-core-login.png" />
					<div class="list-item">
						<div class="item-title">Core Services</div>
						<div class="item-content">We specialize in sample garment production for designers, covering all apparel categories—from small runs to large-scale manufacturing with ease.</div>
					</div>
				</div>
				<div class="list">
					<img src="../../assets/images/icon-pro-login.png" />
					<div class="list-item">
						<div class="item-title">Fabric Supply & In-House Capability</div>
						<div class="item-content">With strong sourcing networks and in-house production, we ensure efficient workflows and strict quality control across cutting, sewing, and finishing. </div>
					</div>
				</div>
				<div class="list">
					<img src="../../assets/images/icon-support-login.png" />
					<div class="list-item">
						<div class="item-title">Pattern & Technical Support</div>
						<div class="item-content">Access our pattern library, upload your own, or request professional pattern-making services to perfectly meet your design requirements. </div>
					</div>
				</div>
				<div class="list">
					<img src="../../assets/images/icon-one-step-login.png" />
					<div class="list-item">
						<div class="item-title">Integrated Management</div>
						<div class="item-content">Comprehensive order management with real-time production tracking and seamless online collaboration, allowing designers to focus on creativity. </div>
					</div>
				</div>
				<div class="list">
					<img src="../../assets/images/icon-money-login.png" />
					<div class="list-item">
						<div class="item-title">Value-Added Services</div>
						<div class="item-content">From approved samples to bulk production or direct upload to leading e-commerce platforms, we help designers turn ideas into successful brands.</div>
					</div>
				</div>
			</div>
		</div>
		<div class="third">
			<div class="third-title"><span>6 Steps</span> Simple to Order Online and Create Your Exclusive Sample Garments
			</div>
			<div class="third-content">
				<div class="content-item">
					<div class="item-num">01</div>
					<div class="item-title">New Style Design </div>
					<div class="item-content">
						Upload your own designed style drawings on the platform and fill in the relevant information for customization requirements as required.
					</div>
					<div class="bottom-icon">
						<img src="../../assets/images/icon-six-step-1.png" />
					</div>
				</div>
				<div class="content-item">
					<div class="item-num">02</div>
					<div class="item-title">Free choice of pattern sources </div>
					<div class="item-content">
						<p>1. Use the platform's existing patterns: quickly apply standard sizes and structures </p>
						<p>2. Upload your own patterns: Import the existing pattern files from the designer
3. Apply for pattern-making services: Custom pattern-making by the platform's professional team </p>
					</div>
					<div class="bottom-icon">
						<img src="../../assets/images/icon-six-step-2.png" />
					</div>
				</div>
				<div class="content-item">
					<div class="item-num">03</div>
					<div class="item-title">Fill in the requirements for craftsmanship/fabrics and accessories </div>
					<div class="item-content">
						Fill in details online including fabric quantity, sewing techniques, special process requirements, etc., and the platform will automatically match available suppliers and production lines.
					</div>
					<div class="bottom-icon">
						<img src="../../assets/images/icon-six-step-3.png" />
					</div>
				</div>
				<div class="content-item">
					<div class="item-num">04</div>
					<div class="item-title">Confirm the quotation and make the payment </div>
					<div class="item-content">
						The platform automatically generates a quotation based on fabrics/accessories, craftsmanship, and quantity. After reviewing and confirming the quotation, designers can complete the payment to officially place the order for production.
					</div>
					<div class="bottom-icon">
						<img src="../../assets/images/icon-six-step-4.png" />
					</div>
				</div>
				<div class="content-item">
					<div class="item-num">05</div>
					<div class="item-title">Production Progress Tracking </div>
					<div class="item-content">
						The order management center updates the production progress in real-time, supports online communication with factories, and promptly handles customers' change requests.
					</div>
					<div class="bottom-icon">
						<img src="../../assets/images/icon-six-step-5.png" />
					</div>
				</div>
				<div class="content-item">
					<div class="item-num">06</div>
					<div class="item-title">Receiving and Reviewing </div>
					<div class="item-content">
						After the finished products are completed, they will be delivered to your door. Designers can conduct online reviews and provide feedback, which will serve as data support for subsequent mass production or improvements.
					</div>
					<div class="bottom-icon">
						<img src="../../assets/images/icon-six-step-6.png" />
					</div>
				</div>
			</div>
		</div>
		<div class="fourth">
			<div class="title-en"></div>
			<div class="title-cn">DRAFT TO REAL</div>
			<div class="content-box" style="justify-">
				<div class="item-box">
					<div class="item-num">30<span>YEAY</span></div>
					<div class="item-content">Deeply rooted in the apparel industry</div>
				</div>
				<div class="item-box">
					<div class="item-num">12<span>million</span></div>
					<div class="item-content">Annual output of finished garments</div>
				</div>
				<div class="item-box">
					<div class="item-num">3500<span>tons</span></div>
					<div class="item-content">Annual output of cloth/fabric</div>
				</div>
			</div>
		</div>
		<div class="fifth">
			<div class="about-content">
				<div class="title-en"></div>
				<div class="title-cn">ABOUT US<span class="line"></span></div>
				<div class="content">
					<div class="title">The Power Behind the Dratf to real</div>
					<div class="content">
						After 33 years of deep cultivation in the apparel industry, the "Yichuang Community" is backed by robust resources across the entire garment industry chain and a mature "intelligent manufacturing" system.

The enterprise has built modern standard factories and intelligent production lines on its own, with an annual output of up to 12 million sets of finished garments and 3,500 tons of fabric. It has achieved a high degree of integration across multiple links, from textile production and embroidery to finished garment manufacturing. Through continuous R&D innovation and quality control, it has enhanced production stability and efficiency. Leveraging its excellent product quality, rich industry experience, and extensive domestic and international market layout, it has successively won numerous important awards in the fields of garment manufacturing and technological innovation.

Its business footprint spans key global regions such as Australia, the United States, New Zealand, and Cambodia. It owns independent brands, overseas marketing teams, and a complete overseas warehousing and logistics system. Maintaining long-term strategic cooperation with many well-known enterprises and institutions, it continues to expand its global market share and brand influence. 。</div>
					<div class="title">Dratf to real——The industry's first AI-powered one-stop service platform for clothing design, production, and sales.  </div>
					<div class="content">
						It is precisely born on the basis of this strong industrial foundation, aiming to provide clothing designers with one-stop support for creative implementation and commercialization.

From sample garment production to the effective connection of flexible supply chain resources, Yichuang Community is committed to building an open, shared, and collaborative ecological platform, enabling more design inspirations to be easily transformed into high-quality finished products.

We hope to work with every partner who loves design and clothing innovation to lead the creative transformation of the clothing industry, create a broader value stage for more brands and individuals, and inject a steady stream of vitality and value into the industry. </div>
				</div>
			</div>
			<div class="bg"></div>
		</div>
		<BindPhone v-if="show_bind_form" @on-close="close_popup" @on-submit="qrcode_login"></BindPhone>

		<popup :show.sync="is_popup_show" width="680px" height="520px" @on-close="close_agreement">
			<div class="agree-content">
				<div v-html="setting.userAgreement"></div>
			</div>
		</popup>
	</div>

</template>

<script>
	import {mapState} from 'vuex'
	import Popup from "@/components/Popup.vue";
	import BindPhone from '@/components/BindPhone/BindPhone.vue';
	import Captcha from "@/components/Captcha.vue";
	import EmailCode from "@/components/EmailCode.vue";
	import { auth } from '@/utils/firebase'
	import firebase from '@/utils/firebase'

	import {
		AccountLogin,
		Register,
		Profile,
		EmailLogin,
		GoogleLogin
	} from "@/api/index.js"

	import util from '@/utils/util'
	export default {
		name: "Login",
		
		components: {
			Captcha,
			EmailCode,
			BindPhone,
			Popup
		},
		data() {
			return {
				is_popup_show: false,
				is_click: false,
				height: '600px',
				form_data: {
					email: '',
					code: '',
					password: '',
					captcha_code: '',
				},
				is_password_show: false,
				captcha_code: '',
				login_mode:'form',
				form_scene:'login',
				login_method:'account',
				password_type:'password',
				show_bind_form: false,
				wechat_qrcode: '',
				is_qrcode_expire: true,
				interval_id: null,
				
			};
		},
		computed: {
			...mapState({
				setting: (state) => state.setting,
			}),
			is_login(){
				return this.$store.state.is_login;
			}
		},
		beforeRouteEnter(to, from, next) {
			next((vm) => {
				// 通过 `vm` 访问组件实例
				vm.$emit("changeFooter", 'light');
			});
		},
		beforeRouteLeave(to, from, next) {
			if(this.interval_id) {
				clearInterval(this.interval_id)
			}
			next();
		},
		mounted(){
			const {type} = this.$route.query;
			if(type){
				switch(type){
					case 'phone':
						this.change_login_mode('form');
						break;
					case 'wechat':
						this.change_login_mode('qrcode')
						break;
				}
			} else {
				this.change_login_mode('qrcode')
			}
		},
		created() {
			this.height = (window.innerHeight - 78) + 'px'
		},
		methods: {
			
			handleGoogleLogin() {
				const provider = new firebase.auth.GoogleAuthProvider()
      
				auth.signInWithPopup(provider).then(result => {
					console.log('Google 登录成功:', result.user)
					let promise = new Promise(((resolve, reject) => {
						let response = GoogleLogin({
							email:result.user.email,
							avatar:result.user.photoURL,
							mobile:result.user.phoneNumber,
						})
						resolve(response)
						
					}))
					promise.then(response => {
						this.$store.commit('login', response.data)
						this.$store.commit('loginType', 'google')
						return Profile()
					}).then(response => {
						this.$store.commit('setUserInfo', response.data)
					}).then(() => {
						this.$router.replace({name: 'WorkBench'})
					})
					promise.catch((res)=>{
						this.$layer.msg(res.msg)
					})
				}).catch(error => {
					console.error('Google 登录失败:', error)
					this.$layer.msg('Google fail')
				})
			},
			handleAppleLogin() {
				const provider = new firebase.auth.OAuthProvider('apple.com')
				auth.signInWithPopup(provider).then(result => {
					console.log('Apple 登录成功:', result.user)
					let promise = new Promise(((resolve, reject) => {
						let response = GoogleLogin({
							email:result.user.email,
							avatar:result.user.photoURL,
							mobile:result.user.phoneNumber,
						})
						resolve(response)
					}))
					promise.then(response => {
						this.$store.commit('login', response.data)
						this.$store.commit('loginType', 'apple')
						return Profile()
					}).then(response => {
						this.$store.commit('setUserInfo', response.data)
					}).then(() => {
						this.$router.replace({name: 'WorkBench'})
					})
					promise.catch((res)=>{
						this.$layer.msg(res.msg)
					})
				}).catch(error => {
					console.error('Apple 登录失败:', error)
					this.$layer.msg('Apple fail')
				})
			},
			

			close_agreement() {
				this.is_popup_show = false
			},
			open_agreement() {
				this.is_popup_show = true
			},

			close_popup() {
				this.show_bind_form = false
				this.is_qrcode_expire = true
				this.change_login_mode('qrcode')
			},
			change_login_mode() {

			},
			toggle_password() {
				this.is_password_show = !this.is_password_show;
			},
			go2find() {
				this.$router.push({name: 'FindPwd'})
			},
			submit() {
				if(this.is_click) {
					return
				}


				this.is_click = true
				let promise = new Promise(((resolve, reject) => {
					let response
					if(this.login_mode === 'form' && this.form_scene === 'login' && this.login_method === 'account') {
						response = AccountLogin(this.form_data)
						resolve(response)
					}
					if(this.login_mode === 'form' && this.form_scene === 'login' && this.login_method === 'email') {
						response = EmailLogin(this.form_data)
						resolve(response)
					}
					if(this.login_mode === 'form' && this.form_scene === 'register') {
						response = Register(this.form_data);
						resolve(response)
					}
					reject({msg: `Login/Register options error`})
				}))
				promise.then(response => {
					this.$store.commit('login', response.data)
					return Profile()
				}).then(response => {
					this.$store.commit('setUserInfo', response.data)
				}).then(() => {
					this.$router.replace({name: 'WorkBench'})
				})
				promise.catch((res)=>{
					this.$layer.msg(res.msg)
				})
				promise.finally(() => {
					this.is_click = false
				})
			},
		},
	};
</script>

<style scoped lang="scss">
@import './login.scss'
</style>
